import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import "./questionnaire.css";
import { APIQuestionnaire } from "api-services";
import PropTypes from "prop-types";

function Questionnaire(props) {
  const { loading } = useSelector((state) => state.authentication);
  const navigate = useNavigate();
  const dispatchData = useDispatch();
  const [showErrorMessage, setShowErrorMessage] = useState("");
  const { token } = useSelector((state) => state.authentication);

  // Questionnaire Form
  const [name, setName] = useState(props.name || "");
  const [email, setEmail] = useState(props.email || "");
  const [liveDate, setLiveDate] = useState("");
  const [clearingDone, setClearingDone] = useState("");
  const [assetClasses, setAssetClasses] = useState("");
  const [msgPerDay, setMsgPerDay] = useState("");
  const [msgPerDayNotNeg, setMsgPerDayNotNeg] = useState("");
  const [latencyReq, setLatencyReq] = useState("");
  const [businessRoute, setBusinessRoute] = useState("");
  const [serversHost, setServersHost] = useState("");
  const [msgPerSecPeak, setMsgPerSecPeak] = useState("");
  const [msgPerSecPeakNotNeg, setMsgPerSecPeakNotNeg] = useState("");
  const [systemProspect, setSystemProspect] = useState("");
  const [succession, setSuccession] = useState(false);
  const [riskcheck, setRiskcheck] = useState("");

  //   Form validation
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  // Validation
  const handleValidation = () => {
    let tempErrors = {};
    let isValid = true;

    if (liveDate.length <= 0) {
      tempErrors["liveDate"] = true;
      isValid = false;
    }

    if (clearingDone.length <= 0) {
      tempErrors["clearingDone"] = true;
      isValid = false;
    }

    if (assetClasses.length <= 0) {
      tempErrors["assetClasses"] = true;
      isValid = false;
    }

    if (msgPerDay.length <= 0) {
      tempErrors["msgPerDay"] = true;
      isValid = false;
    }

    if (Math.sign(msgPerDayNotNeg) === -1) {
      tempErrors["msgPerDayNotNeg"] = true;
      isValid = false;
    }

    if (latencyReq.length <= 0) {
      tempErrors["latencyReq"] = true;
      isValid = false;
    }

    if (businessRoute.length <= 0) {
      tempErrors["businessRoute"] = true;
      isValid = false;
    }

    if (serversHost.length <= 0) {
      tempErrors["serversHost"] = true;
      isValid = false;
    }

    if (msgPerSecPeak.length <= 0) {
      tempErrors["msgPerSecPeak"] = true;
      isValid = false;
    }

    if (Math.sign(msgPerSecPeakNotNeg) === -1) {
      tempErrors["msgPerSecPeakNotNeg"] = true;
      isValid = false;
    }

    if (systemProspect.length <= 0) {
      tempErrors["systemProspect"] = true;
      isValid = false;
    }

    if (!succession) {
      tempErrors["succession"] = true;
      isValid = false;
    }

    // if (succession == false && riskcheck <= 0) {
    //     tempErrors["riskcheck"] = true;
    //     isValid = false;
    // }

    setErrors({ ...tempErrors });
    return isValid;
  };

  const clearFields = () => {
    setName("");
    setEmail("");
    setLiveDate("");
    setClearingDone("");
    setAssetClasses("");
    setMsgPerDay("");
    setMsgPerDayNotNeg("");
    setLatencyReq("");
    setBusinessRoute("");
    setServersHost("");
    setMsgPerSecPeak("");
    setMsgPerSecPeakNotNeg("");
    setSystemProspect("");
    setSuccession("");
    setRiskcheck("");
  };

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValidForm = handleValidation();
    if (isValidForm) {
      setShowErrorMessage("");
      const getVal = succession === true;

      const data = {
        id: "0",
        userName: email,
        apiIdentifier: "0",
        clientName: name,
        dateofLive: liveDate,
        clearingArea: clearingDone,
        assetClassesName: assetClasses,
        msgsPerDayCount: msgPerDay,
        msgsPerSecond: msgPerSecPeak,
        businessRouting: businessRoute,
        serversHosting: serversHost,
        latencyRequirement: latencyReq,
        systemType: systemProspect,
        riskCheck: getVal,
        alternative: riskcheck,
      };
      APIQuestionnaire(
        dispatchData,
        data,
        navigate,
        setShowErrorMessage,
        clearFields
      );
    }
  };

  return (
    <form
      className="col-md-12 col-lg-10 p-lg-5 pt-lg-3 questionnair"
      onSubmit={handleSubmit}
    >
      <h3 className="cred-form-title text-start mb-4">
        API On-Boarding Questionnaire
      </h3>
      <div className="row">
        <div className="d-none">
          <input
            type="text"
            className="form-control "
            id="name"
            name="name"
            value={name}
          />
        </div>
        <div className="d-none">
          <input
            type="text"
            className="form-control "
            id="email"
            name="email"
            value={email}
          />
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="livedate" className="form-label mt-2">
            What is target to Go Live date?{" "}
            <span className="text-danger">*</span>
          </label>
          <input
            type="date"
            className="form-control "
            id="livedate"
            name="livedate"
            placeholder="Full Name*"
            value={liveDate}
            onChange={(e) => {
              setLiveDate(e.target.value);
            }}
          />
          {errors?.liveDate && (
            <p className="text-red">Please select Go Live Date</p>
          )}
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="clearingDone" className="form-label mt-2">
            Where will the clearing be done?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="clearingDone"
            name="clearingDone"
            placeholder="(Velocity, Introduced to Goldman, Pershing)"
            value={clearingDone}
            onChange={(e) => {
              setClearingDone(e.target.value);
            }}
          />
          {errors?.clearingDone && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="assetClasses" className="form-label">
            Which Asset Classes will be sent?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="assetClasses"
            name="assetClasses"
            value={assetClasses}
            onChange={(e) => {
              setAssetClasses(e.target.value);
            }}
          />
          {errors?.assetClasses && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="msgPerDay" className="form-label">
            Count of messages expected per day?
            <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            className="form-control "
            id="msgPerDay"
            name="msgPerDay"
            value={msgPerDay}
            onChange={(e) => {
              setMsgPerDay(e.target.value);
              setMsgPerDayNotNeg(e.target.value);
            }}
          />
          {errors?.msgPerDay && (
            <p className="text-red">This field cannot be empty</p>
          )}
          {errors?.msgPerDayNotNeg && (
            <p className="text-red">Please add non negative number</p>
          )}
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="latencyReq" className="form-label">
            Are there any latency requirements?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="latencyReq"
            name="latencyReq"
            value={latencyReq}
            onChange={(e) => {
              setLatencyReq(e.target.value);
            }}
          />
          {errors?.latencyReq && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-6 mb-3 ">
          <label htmlFor="businessRoute" className="form-label">
            Where will this business be routed?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="businessRoute"
            name="businessRoute"
            value={businessRoute}
            onChange={(e) => {
              setBusinessRoute(e.target.value);
            }}
          />
          {errors?.businessRoute && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-12 mb-3 ">
          <label htmlFor="serversHost" className="form-label">
            Where will the servers be hosted?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="serversHost"
            name="serversHost"
            value={serversHost}
            onChange={(e) => {
              setServersHost(e.target.value);
            }}
          />
          {errors?.serversHost && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-12 mb-3 ">
          <label htmlFor="msgPerSecPeak" className="form-label">
            How many messages per second and peak number
            <span className="text-danger">*</span>
          </label>
          <input
            type="number"
            className="form-control "
            id="msgPerSecPeak"
            name="msgPerSecPeak"
            value={msgPerSecPeak}
            onChange={(e) => {
              setMsgPerSecPeak(e.target.value);
              setMsgPerSecPeakNotNeg(e.target.value);
            }}
          />
          {errors?.msgPerSecPeak && (
            <p className="text-red">This field cannot be empty</p>
          )}
          {errors?.msgPerSecPeakNotNeg && (
            <p className="text-red">Please add non negative number</p>
          )}
        </div>
        <div className="col-12 col-lg-12 mb-3 ">
          <label htmlFor="systemProspect" className="form-label">
            Which system prospect would be using to connect to API?
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control "
            id="systemProspect"
            name="systemProspect"
            placeholder="(Third-Party, Proprietary System, Black Box, Algo, ETC.)"
            value={systemProspect}
            onChange={(e) => {
              setSystemProspect(e.target.value);
            }}
          />
          {errors?.systemProspect && (
            <p className="text-red">This field cannot be empty</p>
          )}
        </div>
        <div className="col-12 col-lg-12 d-flex align-items-center">
          <label htmlFor="riskcheck" className="form-label me-3">
            Risk check to be done through Succession?
            <span className="text-danger">*</span>
          </label>
          <div className="form-check me-2 d-flex align-items-center">
            <input
              type="radio"
              className="form-check-input"
              id="riskcheck"
              name="riskcheck"
              value="false"
              onChange={(e) => {
                setSuccession(e.target.value);
              }}
            />
            <label className="form-check-label mt-1 ms-2" htmlFor="riskcheck">
              Yes
            </label>
          </div>
          <div className="form-check d-flex align-items-center">
            <input
              type="radio"
              className="form-check-input"
              id="riskcheck"
              name="riskcheck"
              value="true"
              onChange={(e) => {
                setSuccession(e.target.value);
              }}
            />
            <label className="form-check-label mt-1 ms-2" htmlFor="riskcheck">
              No
            </label>
          </div>
        </div>
        <div className="d-block mb-2">
          {errors?.succession && (
            <p className="text-red">Please select an option</p>
          )}
        </div>

        {showErrorMessage != "" && (
          <pre className="text-error">{showErrorMessage}</pre>
        )}

        {succession == "true" && (
          <div className="col-12 col-lg-12 mb-3 ">
            <input
              type="text"
              className="form-control "
              id="riskcheck"
              name="riskcheck"
              placeholder="If No, please specify the alternative"
              value={riskcheck}
              onChange={(e) => {
                setRiskcheck(e.target.value);
              }}
            />
          </div>
        )}
        <div className="d-flex justify-content-center col-lg-12 mx-auto mb-3 mt-4">
          <div className="col-6  pe-md-2">
            <button
              className="btn cred-btn-skip col-12"
              onClick={() => navigate("/authentication/sign-up/success")}
            >
              Skip
            </button>
          </div>
          <div className="col-6 ps-md-2">
            <button
              className="btn cred-btn-contact col-12 "
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress
                  size={25}
                  color="white"
                  className="loaderbtn"
                />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

Questionnaire.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
};
export default Questionnaire;
